import { createContext } from 'react'

import { UserContextResult } from './types'

export const UserContext = createContext<UserContextResult | null>(null)
